import { useRouter } from "next/router";

import { useEffect } from "react";
import toast from "react-hot-toast";

import HeadSeo from "components/layout/head-seo";
import Layout from "components/layout/layout";
import { Loader, Text } from "components/ui";

import { ERROR_TYPES } from "@/lib/errors";

import ZettlorService from "services/zettlor-service";

const zettlorService = new ZettlorService();
export default function SourcedJobApplicationRedirectPage() {
  const router = useRouter();

  useEffect(() => {
    const jobPostUuid = router.query.uuid as string;
    const redirectToJobApplication = async () => {
      // Loading the application
      const { data: connectorJobPost, success } = await zettlorService.getSourcedConnectorJobPost(jobPostUuid);
      if (!success || !connectorJobPost) {
        toast.error("The job application could not be loaded");
        const { data: jobPost } = await zettlorService.getJobPost(jobPostUuid);
        if (jobPost) {
          return router.push(`/o/@${jobPost.organization.handle}`);
        } else {
          return router.push(`${ERROR_TYPES.job_post_not_found.url}&errorPath=${router.asPath}`);
        }
      }

      setTimeout(async () => {
        router.push(`/@${connectorJobPost.connector.handle}/${connectorJobPost.uuid}/apply`);
      }, 250);
    };

    if (jobPostUuid) {
      redirectToJobApplication();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.uuid]);

  return (
    <Layout>
      <HeadSeo title="Redirecting you to the job application" />
      <div className="mt-8 text-center">
        <Text variant="h2">Redirecting you to the job application ... </Text>
      </div>

      <Loader className="mt-12" />
    </Layout>
  );
}
